class CollectionChipFilter extends HTMLElement {
    constructor() {
        super();
        this.chips = this.querySelectorAll('[data-collection-handle]');
        this.gridSection = document.querySelector('#product-grid-section');

        if (!this.gridSection) return;

        this.initEvents();
    }

    initEvents() {
        this.chips.forEach(chip => {
            chip.addEventListener('click', (event) => {
                event.preventDefault();
                const handle = chip.dataset.collectionHandle;
                this.loadCollection(handle);
            });
        });
    }

    loadCollection(handle) {
        const url = `/collections/${handle}?section_id=enjp-main-product-grid`;

        fetch(url)
            .then(res => res.text())
            .then(html => {
                const parser = new DOMParser();
                const newDoc = parser.parseFromString(html, 'text/html');
                const newSection = newDoc.querySelector('#product-grid-section');

                if (newSection) {
                    this.gridSection.innerHTML = newSection.innerHTML;
                    window.history.replaceState({}, '', `/collections/${handle}`);
                    window.scrollTo({ top: this.gridSection.offsetTop - 20, behavior: 'smooth' });
                }
            })
            .catch(err => console.error('Error while loading collection: ', err));
    }
}

if (!customElements.get('collection-chip-filter')) {
    customElements.define('collection-chip-filter', CollectionChipFilter);
}
